import { render, staticRenderFns } from "./MaskedPhone.vue?vue&type=template&id=494ce6e8&scoped=true"
import script from "./MaskedPhone.vue?vue&type=script&lang=js"
export * from "./MaskedPhone.vue?vue&type=script&lang=js"
import style0 from "./MaskedPhone.vue?vue&type=style&index=0&id=494ce6e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ce6e8",
  null
  
)

export default component.exports